import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { getFile } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { CircularProgress } from "@mui/material";
import { FilesCard } from "./FilesCard";

export function FilesPage() {
  const { fileID } = useParams();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const { openError } = usePopupNotificationContext();
  useEffect(() => {
    const asyncFetchFile = async () => {
      setLoading(true);
      try {
        const file = await getFile(fileID);
        setFile(file);
      } catch (err) {
        openError("Någonting gick fel", 3000);
        console.err(err);
      } finally {
        setLoading(false);
      }
    };
    asyncFetchFile();
  }, [fileID]);

  if (loading) {
    return <CircularProgress />;
  }

  if (!file) {
    return (
      <Typography
        variant="h5"
        textAlign="center"
      >{`Fil - ${fileID} hittas ej`}</Typography>
    );
  }

  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {"Fil - "}
          {file.Id}
        </Typography>
        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} md={12}>
            <FilesCard file={file} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
